module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0093.jpg?v=533ad4f0";